
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/macro-survey",
      function () {
        return require("private-next-pages/macro-survey.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/macro-survey"])
      });
    }
  